// Strings for Dashboard, Landing, Auth, InviteAccept and Profile.
const strings = {
  es: {
    // Dashboard
    dash_hello: "Hola, {name}",
    dash_today_agenda: "Agenda de hoy",
    dash_today_agenda_team: "Citas de hoy en la clínica",
    dash_no_appts_today: "No hay citas para hoy",
    dash_no_appts_today_hint: "Las citas que se agenden para hoy aparecerán aquí.",
    dash_see_all_appts: "Ver todas las citas",
    dash_new_appt: "Nueva cita",
    dash_appts_count: "{n} citas",
    dash_appts_count_one: "1 cita",
    dash_unassigned_patients: "Pacientes sin médico asignado",
    dash_unassigned_hint: "Asígnales un médico para que puedan atenderse y aparecer en su agenda.",
    dash_unassigned_none: "Todos los pacientes tienen médico asignado.",
    dash_review_patients: "Revisar pacientes",
    dash_quick_links: "Accesos rápidos",
    dash_followups_desc: "Confirma citas y da seguimiento a pacientes.",
    dash_reports_desc: "Productividad, citas y documentación por médico.",
    dash_users_desc: "Usuarios, roles y accesos.",
    dash_to_confirm: "Citas por confirmar",
    dash_to_confirm_hint: "Próximos 3 días",
    dash_followups_due: "Seguimientos pendientes",
    dash_followups_due_hint: "Para hoy o atrasados",
    dash_today_hint: "Sin contar canceladas",
    dash_my_doctors: "Médicos asignados",
    dash_log_contact: "Registrar contacto",
    dash_clinics_list: "Clínicas",
    dash_no_clinics: "Aún no hay clínicas registradas",
    dash_doctor_count: "{n} médicos",
    dash_doctor_count_one: "1 médico",
    dash_open_reports: "Ver reportes",
    dash_open_users: "Ver usuarios",
    dash_no_reason: "Sin motivo registrado",
    // Landing
    landing_f_nom_title: "Cumplimiento NOM-004",
    landing_f_nom_desc: "Expedientes clínicos completos con interrogatorio, exploración física, diagnósticos CIE-10 y firma del médico.",
    landing_f_ai_title: "Asistente IA",
    landing_f_ai_desc: "Redacta notas y recetas más rápido con apoyo de inteligencia artificial. El médico siempre revisa y firma.",
    landing_f_appts_title: "Citas y recordatorios",
    landing_f_appts_desc: "Agenda por médico, recordatorios por correo y WhatsApp, y confirmación de asistencia.",
    landing_f_rx_title: "Recetas en PDF",
    landing_f_rx_desc: "Genera recetas profesionales con tu cédula y el logotipo de tu clínica, listas para imprimir.",
    landing_f_team_title: "Todo tu equipo",
    landing_f_team_desc: "Clínicas, médicos y asistentes con permisos por rol. Las asistentes gestionan agenda y seguimiento sin ver el expediente clínico.",
    landing_f_followup_title: "Seguimiento de pacientes",
    landing_f_followup_desc: "Cola de citas por confirmar y pacientes por contactar, con historial de cada llamada o mensaje.",
    landing_hero_alt: "Consultorio médico",
    landing_switch_lang: "Cambiar idioma a inglés",
    landing_privacy: "Aviso de privacidad",
    landing_privacy_desc: "Información sobre el tratamiento de datos personales.",
    landing_privacy_body: "ClinicOS es una plataforma que utilizan clínicas y médicos para gestionar expedientes clínicos. Cada clínica o médico es responsable del tratamiento de los datos personales de sus pacientes y debe publicar y entregar su propio aviso de privacidad conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.",
    landing_privacy_contact: "Para dudas sobre la plataforma escríbenos a",
    landing_contact: "Contacto",
    landing_close: "Cerrar",
    // Auth
    auth_subtitle: "Accede a tu consultorio",
    auth_register_subtitle: "Crea la cuenta de tu clínica o consultorio",
    auth_show_password: "Mostrar contraseña",
    auth_hide_password: "Ocultar contraseña",
    auth_role_clinic_desc: "Clínica: administra médicos, asistentes y pacientes de tu clínica.",
    auth_role_doctor_desc: "Médico independiente: consultorio propio, con tus pacientes y recetas.",
    auth_invited_note: "¿Trabajas en una clínica? Los médicos de clínica y las asistentes reciben una invitación por correo de su clínica; no necesitan registrarse aquí.",
    auth_forgot: "¿Olvidaste tu contraseña?",
    auth_forgot_hint: "Pide a tu clínica o al administrador que restablezca tu contraseña.",
    auth_account_type: "Tipo de cuenta",
    password_min_hint: "Mínimo 8 caracteres.",
    password_too_short: "La contraseña debe tener al menos 8 caracteres.",
    // Invite
    inv_confirm_password: "Confirmar contraseña",
    inv_password_mismatch: "Las contraseñas no coinciden.",
    inv_invalid_title: "Invitación no válida",
    inv_invalid_hint: "El enlace expiró o ya se usó. Pide a tu clínica que te reenvíe la invitación.",
    // Profile
    prof_account: "Cuenta",
    prof_login_email: "Correo de acceso",
    prof_login_email_hint: "Para cambiar tu correo de acceso contacta al administrador.",
    prof_contact_email: "Correo de contacto",
    prof_contact_email_hint: "Correo público para pacientes; no cambia tu correo de acceso.",
    prof_clinic_data: "Datos de la clínica",
    prof_doctor_data: "Datos profesionales",
    prof_logo_shared_hint: "Este logotipo es el mismo que se muestra a tu equipo. El nombre de la plataforma se cambia en Configuración.",
    prof_go_settings: "Ir a Configuración",
    prof_on_prescriptions: "Aparece en tus recetas.",
    prof_cedula_missing: "Agrega tu cédula profesional: la NOM-004 la exige en las recetas.",
    prof_change_password: "Cambiar contraseña",
    prof_change_password_desc: "Usa una contraseña que no uses en otros sitios.",
    prof_current_password: "Contraseña actual",
    prof_cedula_esp: "Cédula de especialidad",
    prof_cedula_esp_hint: "Opcional. Aparece en tus recetas junto a tu cédula profesional.",
    prof_institution: "Institución que otorgó el título",
    prof_new_password: "Nueva contraseña",
    prof_confirm_password: "Confirmar nueva contraseña",
    prof_password_changed: "Contraseña actualizada",
    prof_update_password: "Actualizar contraseña",
    prof_name_required: "El nombre es obligatorio.",
    prof_url_ph: "https://",
    prof_logo_too_big: "La imagen es demasiado grande (máx. 2 MB).",
  },
  en: {
    dash_hello: "Hi, {name}",
    dash_today_agenda: "Today's schedule",
    dash_today_agenda_team: "Today's appointments at the clinic",
    dash_no_appts_today: "No appointments today",
    dash_no_appts_today_hint: "Appointments scheduled for today will show up here.",
    dash_see_all_appts: "See all appointments",
    dash_new_appt: "New appointment",
    dash_appts_count: "{n} appointments",
    dash_appts_count_one: "1 appointment",
    dash_unassigned_patients: "Patients without an assigned doctor",
    dash_unassigned_hint: "Assign them a doctor so they can be seen and show up on a schedule.",
    dash_unassigned_none: "Every patient has an assigned doctor.",
    dash_review_patients: "Review patients",
    dash_quick_links: "Quick links",
    dash_followups_desc: "Confirm appointments and follow up with patients.",
    dash_reports_desc: "Productivity, appointments and documentation per doctor.",
    dash_users_desc: "Users, roles and access.",
    dash_to_confirm: "Appointments to confirm",
    dash_to_confirm_hint: "Next 3 days",
    dash_followups_due: "Follow-ups due",
    dash_followups_due_hint: "Due today or overdue",
    dash_today_hint: "Excluding cancelled",
    dash_my_doctors: "Assigned doctors",
    dash_log_contact: "Log contact",
    dash_clinics_list: "Clinics",
    dash_no_clinics: "No clinics registered yet",
    dash_doctor_count: "{n} doctors",
    dash_doctor_count_one: "1 doctor",
    dash_open_reports: "See reports",
    dash_open_users: "See users",
    dash_no_reason: "No reason recorded",
    landing_f_nom_title: "NOM-004 compliant",
    landing_f_nom_desc: "Complete clinical records with interrogation, physical exam, ICD-10 diagnoses and physician signature.",
    landing_f_ai_title: "AI assistant",
    landing_f_ai_desc: "Draft notes and prescriptions faster with AI support. The doctor always reviews and signs.",
    landing_f_appts_title: "Appointments and reminders",
    landing_f_appts_desc: "Per-doctor scheduling, email and WhatsApp reminders, and attendance confirmation.",
    landing_f_rx_title: "PDF prescriptions",
    landing_f_rx_desc: "Generate professional prescriptions with your license number and clinic logo, ready to print.",
    landing_f_team_title: "Your whole team",
    landing_f_team_desc: "Clinics, doctors and assistants with role-based permissions. Assistants manage scheduling and follow-up without seeing clinical records.",
    landing_f_followup_title: "Patient follow-up",
    landing_f_followup_desc: "Queues of appointments to confirm and patients to contact, with a history of every call or message.",
    landing_hero_alt: "Doctor's office",
    landing_switch_lang: "Switch language to Spanish",
    landing_privacy: "Privacy notice",
    landing_privacy_desc: "Information about how personal data is handled.",
    landing_privacy_body: "ClinicOS is a platform used by clinics and doctors to manage clinical records. Each clinic or doctor is responsible for their patients' personal data and must publish and provide their own privacy notice under Mexico's Federal Law on the Protection of Personal Data Held by Private Parties.",
    landing_privacy_contact: "For questions about the platform, write to",
    landing_contact: "Contact",
    landing_close: "Close",
    auth_subtitle: "Access your practice",
    auth_register_subtitle: "Create the account for your clinic or practice",
    auth_show_password: "Show password",
    auth_hide_password: "Hide password",
    auth_role_clinic_desc: "Clinic: manage your clinic's doctors, assistants and patients.",
    auth_role_doctor_desc: "Independent doctor: your own practice, patients and prescriptions.",
    auth_invited_note: "Work at a clinic? Clinic doctors and assistants get an email invitation from their clinic; they don't need to sign up here.",
    auth_forgot: "Forgot your password?",
    auth_forgot_hint: "Ask your clinic or the administrator to reset your password.",
    auth_account_type: "Account type",
    password_min_hint: "At least 8 characters.",
    password_too_short: "The password must be at least 8 characters.",
    inv_confirm_password: "Confirm password",
    inv_password_mismatch: "Passwords don't match.",
    inv_invalid_title: "Invalid invitation",
    inv_invalid_hint: "The link expired or was already used. Ask your clinic to resend the invitation.",
    prof_account: "Account",
    prof_login_email: "Sign-in email",
    prof_login_email_hint: "To change your sign-in email, contact the administrator.",
    prof_contact_email: "Contact email",
    prof_contact_email_hint: "Public email for patients; it doesn't change your sign-in email.",
    prof_clinic_data: "Clinic details",
    prof_doctor_data: "Professional details",
    prof_logo_shared_hint: "This logo is the same one your team sees. The platform name is changed in Settings.",
    prof_go_settings: "Go to Settings",
    prof_on_prescriptions: "Shown on your prescriptions.",
    prof_cedula_missing: "Add your professional license (cédula): NOM-004 requires it on prescriptions.",
    prof_change_password: "Change password",
    prof_change_password_desc: "Use a password you don't use on other sites.",
    prof_current_password: "Current password",
    prof_cedula_esp: "Specialty license",
    prof_cedula_esp_hint: "Optional. Shown on your prescriptions next to your professional license.",
    prof_institution: "Degree-granting institution",
    prof_new_password: "New password",
    prof_confirm_password: "Confirm new password",
    prof_password_changed: "Password updated",
    prof_update_password: "Update password",
    prof_name_required: "Name is required.",
    prof_url_ph: "https://",
    prof_logo_too_big: "The image is too large (max 2 MB).",
  },
};

export default strings;
